import { useEffect, useState } from "react";
import { SITE } from "../lib/site";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
          aria-label="Shine and Drive — home"
        >
          <img
            src={SITE.media.logo}
            alt="Shine and Drive Car Cleaning"
            className="h-12 w-12 object-contain"
          />
          <span className="hidden sm:inline font-display text-lg tracking-wide text-white/90">
            Shine <span className="text-gold italic">&amp;</span> Drive
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm uppercase tracking-[0.18em] text-white/70 hover:text-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href={SITE.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-book-now"
            className="inline-flex items-center gap-2 px-5 py-2.5 border border-gold/70 text-gold rounded-full text-sm uppercase tracking-[0.18em] hover:bg-gold hover:text-black transition-all"
          >
            Book Now
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="text-white/80 uppercase tracking-[0.18em] text-sm"
              >
                {l.label}
              </a>
            ))}
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-mobile-book-now"
              className="mt-2 inline-flex justify-center px-5 py-3 border border-gold/70 text-gold rounded-full text-sm uppercase tracking-[0.18em]"
            >
              Book Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
